<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
          <ul v-show='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
          <label>العرض:</label>
          <select :disabled="contractOfferId > 0"  @change="changePriceType($event.target.value)" class="form-control" style="padding: 0px" v-model="record.offer_id">
            <option  v-for="offer in offers" v-bind:key="offer.id"  v-bind:value="offer.id">
              {{offer.offer_name}} - {{offer.price}}
            </option>
          </select>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>كود العقد:</label>
          <input  @keypress="isNumber($event)" v-model='record.rec_id' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>كود الايصال:</label>
          <input  @keypress="isNumber($event)" v-model='record.receipt_id' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-1 col-sm-1' style='padding: 10px 0px 0px 10px;'>
          <label>النوع:</label>
          <select @change="changePriceType($event.target.value)" class="form-control" style="padding: 0px" v-model="record.price_type">
            <option  v-for="type in Paytypes" v-bind:key="type.id"  v-bind:value="type.id">
              {{type.name}}
            </option>
          </select>
        </div>
        <div class='col-lg-1 col-sm-1' style='padding: 10px 0px 0px 0px;'>
          <label>الحالة:</label>
          <select class="form-control" style="padding: 0px" v-model="record.state">
            <option  v-for="type in types" v-bind:key="type.id"  v-bind:value="type.id">
              {{type.name}}
            </option>
          </select>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 10px 0px 0px;'>
          <tbDate :mytitle='dateTitle' v-model= 'record.date' ></tbDate>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>المفوض:</label>
          <select class="form-control" style="padding: 0px" v-model="record.teller_user_id">
            <option v-for="item in delegates" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>الفنى:</label>
          <select class="form-control" style="padding: 0px" v-model="record.tec_user_id">
            <option v-for="item in technicals" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>الخزنة:</label>
          <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
            <option v-for="item in treasuries" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 0px;'>
          <label>المخزن:</label>
          <select class="form-control" style="padding: 0px" v-model="store_id">
            <option v-for="item in stores" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>السعر:</label>
          <input  @keypress="isLocked($event)"  :value='record.price' class='form-control' name='price' type='text'>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>الخصم:</label>
          <input  @keypress="isNumber($event)"  v-on:input="changeAmount()" v-model='record.discount' class='form-control' name='discount' type='text'>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>المطلوب:</label>
          <input  @keypress="isLocked($event)"  :value='record.amount' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>المدفوع:</label>
          <input  :disabled="record.price_type == 1" @keypress="isNumber($event)" @keyup='getRest()' v-model='record.paid' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 0px;'>
          <label>الباقى:</label>
          <div class="form-group input-group">
            <input  :disabled="record.price_type == 1" @keypress="isLocked($event)" v-model='record.rest' class='form-control' name='rest' type='text'>
              <span class="input-group-btn">
                  <button class="btn btn-default" @click="inputEmpty()" type="button" style = "color: red;">X</button>
              </span>
          </div>
        </div>
        <div v-if="record.price_type == 0" class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>تاريـخ سداد المقدم:</label>
          <div class="form-group input-group" style='margin: 0px'>
            <Datepicker :disabled="record.price_type == 1" :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.presenter_date'></Datepicker>
          </div>
        </div>
        <div v-if="record.price_type == 0" class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>عدد الأقساط:</label>
          <select :disabled="record.price_type == 1" class="form-control" style="padding: 0px" v-model="record.installment_count">
            <option v-for="n in 10" :key="n" :value="n">
              {{ n }}
            </option>
          </select>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
          <label>قيمة القسط:</label>
          <input :disabled="record.price_type == 1"  @keypress="isNumber($event)" v-model='record.installment' class='form-control' name='installment' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <label>فترة السداد:</label>
          <select :disabled="record.price_type == 1" class="form-control" style="padding: 0px" v-model="record.installment_period_monthly">
            <option v-for="item in periodMonthlyType" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 0px;'>
          <label>بداية السداد:</label>
          <div class="form-group input-group" style='margin: 0px'>
            <Datepicker :disabled="record.price_type == 1" :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.installment_data'></Datepicker>
          </div>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 0px;'>
          <label>ملاحظات:</label>
          <input  v-model='record.notes' class='form-control' name='notes' type='text'>
        </div>
        <div class='col-lg-4 col-sm-4  col-lg-offset-4  col-sm-offset-4' style='padding: 10px 0px 0px 10px;text-align:center;'>
          <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
          <button @click='newData()'    type='button' class='btn btn-outline btn-sm btn-success'>جديد</button>
          <button v-show="record.id > -1" @click='saveData()'   type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
          <button v-show="record.id >   0" @click='deleteData()' type='button' class='btn btn-outline btn-danger btn-sm'>حذف</button>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
          <label>عروض سابقة:</label>
          <select  @change="getOfferRecords($event.target.value)" class="form-control" style="padding: 0px" v-model="contractOfferId">
            <option  v-for="offer in contract_offers" v-bind:key="offer.id"  v-bind:value="offer.id">
              {{offer.date}} => {{offer.offer_name}}
            </option>
          </select>
        </div>
        <div v-show = "contractOfferId > 0" class="col-lg-12" style='padding: 10px 0px 0px 10px'>
          <!-- Nav tabs -->
          <ul class="nav nav-tabs">
            <li class="active"><a href="#home" data-toggle="tab">العرض</a>
            </li>
            <li><a href="#details" data-toggle="tab">تفاصيل</a>
            </li>
            <li><a href="#balance" data-toggle="tab">كشف حساب</a>
            </li>
          </ul>
          <vue-element-loading size='32' :active='isOfferRecordsLoading' spinner='bar-fade-scale' color='#A4A4A4'/>
          <!-- Tab panes -->
          <div class="tab-content">
            <div class="tab-pane fade in active" id="home">
              <table width='100%' class='table  table-bordered ' >
                <thead>
                  <tr>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الصنف</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>العدد</th>
                    <th colspan=2 style='vertical-align: middle;padding:2px;text-align: center'>ما تم</th>
                    <th colspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الباقى</th>
                  </tr>
                  <tr>
                    <th style='padding:2px;text-align: center'>صرف</th>
                    <th style='padding:2px;text-align: center'>تركيب</th>
                    <th style='padding:2px;text-align: center'>صرف</th>
                    <th style='padding:2px;text-align: center'>تركيب</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for='record in OfferRecords' :key='record.id' >
                    <td style="padding:2px" align='center'>{{record.item}}</td>
                    <td style="padding:2px" align='center'>{{record.count}}</td>
                    <td style="padding:2px" align='center'>{{record.r1}}</td>
                    <td style="padding:2px" align='center'>{{record.r2}}</td>
                    <td style="padding:2px" align='center'>{{record.r3}}</td>
                    <td style="padding:2px" align='center'>{{record.r4}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane fade" id="details">
              <table width='100%' class='table  table-bordered ' >
                <thead>
                  <tr>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>الصنف</th>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>التاريخ الافتراضى</th>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>تاريخ التغيير</th>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>الفنى</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for='record in maintenancRecords' :key='record.id' >
                    <td style="padding:2px" align='center'>{{record.item}}</td>
                    <td style="padding:2px" align='center'>{{record.default_date}}</td>
                    <td style="padding:2px" align='center'>{{record.change_date}}</td>
                    <td style="padding:2px" align='center'>{{record.name}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane fade" id="balance">
              <table width='100%' class='table  table-bordered ' >
                <thead>
                  <tr>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>التاريخ</th>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>الحركة</th>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>الفنى</th>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>المطلوب</th>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>المدفوع</th>
                    <th style='vertical-align: middle;padding:2px;text-align: center'>الرصيد</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for='record in ContractOffersBalance' :key='record.id' >
                    <td style="padding:2px" align='center'>{{record.date}}</td>
                    <td style="padding:2px" align='center'>{{record.type}}</td>
                    <td style="padding:2px" align='center'>{{record.name}}</td>
                    <td style="padding:2px" align='center'>{{record.amount}}</td>
                    <td style="padding:2px" align='center'>{{record.paid}}</td>
                    <td style="padding:2px" align='center'>{{record.total}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /.col-lg-6 -->
        <div v-show = "contractOfferId === 0 && record.offer_id > 0" class="col-lg-12" style='padding: 10px 0px 0px 10px'>
          <table width='100%' class='table table-striped table-bordered table-hover' >
            <thead>
              <tr>
                <th style='padding:2px;text-align: center'>الصنف</th>
                <th style='padding:2px;text-align: center'><input @click="selectDelivery($event.target.value)" v-model="selectedDelivery" type="checkbox" value=""> تسليم </th>
                <th style='padding:2px;text-align: center'><input @click="selectInstallation($event.target.value)" v-model="selectedInstallation" type="checkbox" value=""> تغيير</th>
              </tr>
            </thead>
            <tbody>
              <tr class='odd gradeX' v-for='(record) in offerItems' :key='record.id'>
                <td style='padding:2px;text-align: center'>{{record.item}}</td>
                <td style='padding:2px;text-align: center'><input type="checkbox" :id="record.id" @click="selectItemDelivery($event.target.value, record.id)" v-model="record.delivery" :value="record.delivery"></td>
                <td style='padding:2px;text-align: center'><input type="checkbox" :id="record.id" @click="selectItemInstallation($event.target.value, record.id)" v-model="record.Installation" :value="record.Installation"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import Swal from 'sweetalert2'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    tbDate,
    Datepicker
  },
  name: 'om',
  data () {
    return {
      ar: ar,
      ContractOffersBalance: '',
      selectedDelivery: true,
      selectedInstallation: true,
      offerItems: [],
      today: true,
      payDateTitle: 'أول قسط',
      dateTitle: 'التاريخ',
      installmentDateTitle: 'تاريخ القسط',
      validationErrors: '',
      records: {},
      record: {},
      offers: {},
      offer_id: 0,
      treasuries: {},
      items: {},
      technicals: {},
      delegates: {},
      contract_offers: {},
      contractOfferId: 0,
      OfferRecords: {},
      maintenancRecords: {},
      ChangePlans: {},
      stores: {},
      store_id: '',
      periodMonthlyType: [{id: null, name: ''}, {id: 1, name: 'شهرى'}, {id: 2, name: 'كل شهرين'}, {id: 3, name: 'كل 3 شهور'}, {id: 4, name: 'كل أربع شهور'}],
      types: [{id: 0, name: 'غير نشط'}, {id: 1, name: 'نشط'}],
      Paytypes: [{id: 0, name: 'قسط'}, {id: 1, name: 'كاش'}, {id: 2, name: 'هدية'}],
      btnTitle: 'عرض الكل',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      Localcontract_id: 0,
      isContractOffersLoading: false,
      isOfferRecordsLoading: false,
      branches: {}
    }
  },
  computed: {
    contractItems () {
      return this.items.filter(item => item.is_contract === 0)
    }
  },
  methods: {
    tabSelected () {
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      this.validationErrors = ''
      this.contract_offers = ''
      this.contractOfferId = 0
      this.OfferRecords = ''
      this.maintenancRecords = ''
      this.ChangePlans = ''
      this.store_id = ''
      this.success = ''
      this.record = {}
      // =========================================================================
      this.newData()
      this.UpdateData()
      this.contractOffers()
    },
    // =========================================================================
    changeAmount () {
      if (parseInt(this.record.price || 0) - parseInt(this.record.discount || 0) < 0) {
        this.record.discount = this.record.price
      }
      this.record.amount = parseInt(this.record.price || 0) - parseInt(this.record.discount || 0)
      if (parseInt(this.record.price_type) > 0) {
        this.record.paid = parseInt(this.record.price || 0) - parseInt(this.record.discount || 0)
      } else {
        this.record.rest = parseInt(this.record.amount || 0) - parseInt(this.record.paid || 0)
        this.calcTotalInstallments()
      }
      // this.record.paid = this.record.amount
      // this.record.rest = 0
    },
    // =====================================================
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    // =========================================================================
    UpdateData () {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(this.$store.state.customerData.branche_id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
        this.technicals = this.branches[i].technicals
        this.delegates = this.branches[i].delegates
        this.stores = this.branches[i].stores
      }
      this.getActiveOffers()
    },
    // =========================================================================
    inputEmpty (id) {
      this.record.installment_count = null
      this.record.presenter_date = null
      this.record.installment = null
      this.record.installment_period_monthly = null
      this.record.installment_data = null
      this.record.rest = 0
      this.record.paid = this.record.amount
    },
    // =========================================================================
    getRest () {
      let paid = parseInt(this.record.amount || 0) - parseInt(this.record.paid || 0)
      this.record.rest = paid
    },
    // =========================================================================
    getActiveOffers () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getActiveOffers', {
        token: localStorage.getItem('token'),
        branch_id: this.$store.state.customerData.branche_id,
        Contract_id: this.$store.state.customerData.contract_id
      })
        .then(res => {
          this.isLoadingData = false
          this.offers = res.data.offers
          this.ChangePlans = res.ChangePlan
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // =========================================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // =========================================================================
    isLocked: function (evt) {
      evt.preventDefault()
    },
    // =========================================================================
    contractOffers () {
      this.contractOfferId = 0
      this.contract_offers = ''
      this.isContractOffersLoading = true
      axios.post(this.$apiURL + 'getContractOffers', {
        token: localStorage.getItem('token'),
        contract_id: this.$store.state.customerData.contract_id
      })
        .then(res => {
          this.isContractOffersLoading = false
          this.contract_offers = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isContractOffersLoading = false
        })
    },
    // =========================================================================
    newData () {
      this.store_id = ''
      this.offerItems = []
      this.OfferRecords = ''
      this.contractOfferId = 0
      this.validationErrors = ''
      this.maintenancRecords = ''
      this.success = ''
      this.errorShow = false
      this.successShow = false
      this.record = {'id': 0, 'contract_id': '', 'offer_id': '', 'date': '', 'amount': 0, 'presenter_date': null, 'discount': 0, 'paid': 0, 'treasury_id': '', 'rest': 0, 'installment': null, 'installment_count': null, 'teller_user_id': '', 'state': 1, 'notes': '', 'installment_data': null, 'tec_user_id': '', 'label': '', 'price_type': 1, 'rec_id': '', 'installment_period_monthly': null, 'receipt_id': ''}
    },
    // ==================================================================
    getOfferRecords (rec) {
      this.validationErrors = ''
      this.isOfferRecordsLoading = true
      axios.post(this.$apiURL + 'getOfferRecords', {
        token: localStorage.getItem('token'),
        contract_id: this.$store.state.customerData.contract_id,
        id: rec
      })
        .then(res => {
          this.isOfferRecordsLoading = false
          this.OfferRecords = res.data.OfferRecords
          this.maintenancRecords = res.data.Maintenance
          this.ContractOffersBalance = res.data.ContractOffersBalance
          this.record = res.data.contract_offers
          var total = 0
          for (let i = 0; i < this.ContractOffersBalance.length; i++) {
            total = total + this.ContractOffersBalance[i].total
            this.ContractOffersBalance[i].total = total
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isOfferRecordsLoading = false
        })
    },
    // ==================================================================
    changePriceType () {
      this.offerItems = []
      // -----------------------------------------------------
      let i = this.offers.findIndex(x => x.id === parseInt(this.record.offer_id))
      if (i > -1) {
        if (parseInt(this.record.price_type) === 1) {
          this.record.price = this.offers[i].price
        } else {
          this.record.price = this.offers[i].installment_price
        }
        // -----------------------------------------------
        this.selectedDelivery = true
        this.selectedInstallation = true
        for (let y = 0; y < this.offers[i].offer_items.length; y++) {
          for (let c = 0; c < this.offers[i].offer_items[y].item_pieces; c++) {
            this.offerItems[this.offerItems.length] = {}
            this.offerItems[this.offerItems.length - 1].id = this.offerItems.length
            this.offerItems[this.offerItems.length - 1].Installation = 1
            this.offerItems[this.offerItems.length - 1].delivery = 1
            this.offerItems[this.offerItems.length - 1].item_id = this.offers[i].offer_items[y].item_id
            this.offerItems[this.offerItems.length - 1].item = this.offers[i].offer_items[y].item
          }
        }
        // -----------------------------------------------
        if (parseInt(this.record.price_type) === 1) {
          this.record.paid = this.record.price
          this.record.amount = this.record.price
          this.record.rest = ''
          this.record.installment = null
          this.record.installment_period_monthly = null
          this.record.installment_data = null
        } else {

        }
        // -----------------------------------------------
        this.getRest()
      }
    },
    // ==================================================================
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.Localcontract_id = this.record.contract_id
        this.record = {'id': 0, 'contract_id': '', 'offer_id': '', 'date': '', 'price': 0, 'amount': 0, 'paid': 0, 'treasury_id': '', 'rest': '', 'installment': null, 'teller_user_id': '', 'state': 1, 'notes': '', 'installment_data': null, 'tec_user_id': '', 'label': '', 'price_type': '', 'rec_id': '', 'installment_period_monthly': null, 'receipt_id': ''}
        this.record.contract_id = this.Localcontract_id
      } else {
        this.record = recID
      }
    },
    // ==================================================================
    selectInstallation (id) {
      for (let c = 0; c < this.offerItems.length; c++) {
        this.offerItems[c].Installation = event.target.checked
        if (event.target.checked === true) {
          this.offerItems[c].delivery = event.target.checked
          this.selectedDelivery = true
        }
      }
      this.$forceUpdate()
    },
    // ==================================================================
    selectDelivery (id) {
      for (let c = 0; c < this.offerItems.length; c++) {
        this.offerItems[c].delivery = event.target.checked
        if (event.target.checked === false) {
          this.offerItems[c].Installation = event.target.checked
          this.selectedInstallation = false
        }
      }
      this.$forceUpdate()
    },
    // ==================================================================
    selectItemInstallation (id, i) {
      if (event.target.checked === true) {
        let c = this.offerItems.findIndex(x => x.id === parseInt(i))
        this.offerItems[c].delivery = event.target.checked
        this.selectedInstallation = false
        this.selectedDelivery = false
      }
      this.$forceUpdate()
    },
    // ==================================================================
    selectItemDelivery (id, i) {
      if (event.target.checked === false) {
        let c = this.offerItems.findIndex(x => x.id === parseInt(i))
        this.offerItems[c].Installation = event.target.checked
        this.selectedInstallation = false
        this.selectedDelivery = false
      }
      this.$forceUpdate()
    },
    // ==================================================================
    saveData () {
      this.validationErrors = []
      var isError = false
      if (parseInt(this.record.price_type) === 0) {
        if (parseInt(this.record.paid) >= parseInt(this.record.amount)) {
          this.validationErrors.push('يجب ان يكون المدفوع اقل من المبلغ فى العقود القسط')
          isError = true
        }
        if (parseInt(this.record.installment) > parseInt(this.record.rest)) {
          this.validationErrors.push('يجب ان يكون قيمة القسط اقل من المبلغ الباقى')
          isError = true
        }
        if (parseInt(this.record.installment) === 0 || this.record.installment === null || this.record.installment === '') {
          this.validationErrors.push('يجب ادخال قيمة القسط')
          isError = true
        }
        if (parseInt(this.record.installment_count) === 0 || this.record.installment_count === null || this.record.installment_count === '') {
          this.validationErrors.push('يجب اختيار عدد الاقساط')
          isError = true
        }
        if (this.record.installment_period_monthly === null) {
          this.validationErrors.push('يجب اختيار فترة السداد')
          isError = true
        }
        if (!moment(this.record.installment_data, 'YYYY-MM-DD', true).isValid()) {
          this.validationErrors.push('يجب ادخال تاريخ بداية السداد')
          isError = true
        } else {
          this.record.installment_data = moment(this.record.installment_data).format('YYYY-MM-DD')
        }
        if (moment(this.record.presenter_date, 'YYYY-MM-DD', true).isValid()) {
          this.record.presenter_date = moment(this.record.presenter_date).format('YYYY-MM-DD')
        }
      } else {
        if (parseInt(this.record.installment) > 0) {
          this.validationErrors.push('خطأ فى نوع العقد')
          isError = true
        }
        if (this.record.installment_period_monthly > 0) {
          this.validationErrors.push('خطأ فى نوع العقد')
          isError = true
        }
        if (this.record.installment_data !== '' && this.record.installment_data !== null) {
          this.validationErrors.push('خطأ فى نوع العقد')
          isError = true
        }
        if (parseInt(this.record.rest) > 0) {
          this.validationErrors.push('خطأ فى نوع العقد')
          isError = true
        }
      }
      if (isError === true) {
        return
      }
      this.validationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveContractOffers', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        customer_id: this.$store.state.customerData.id,
        contract_id: this.$store.state.customerData.contract_id,
        offer_id: this.record.offer_id,
        amount: this.record.amount,
        date: this.record.date,
        paid: this.record.paid,
        treasury_id: this.record.treasury_id,
        rest: this.record.rest,
        installment: this.record.installment,
        installment_data: this.record.installment_data,
        installment_period_monthly: this.record.installment_period_monthly,
        offer_teller_user_id: this.record.teller_user_id,
        tec_user_id: this.record.tec_user_id,
        delivery_date: this.record.date,
        delivery_technical_id: this.record.tec_user_id,
        label: this.record.label,
        state: this.record.state,
        notes: this.record.notes,
        price_type: this.record.price_type,
        rec_id: this.record.rec_id,
        receipt_id: this.record.receipt_id,
        store_id: this.store_id,
        price: this.record.price,
        presenter_date: this.record.presenter_date,
        installment_count: this.record.installment_count,
        discount: this.record.discount,
        offerItems: this.offerItems
      })
        .then(res => {
          this.isLoadingSave = false
          this.contract_offers = res.data.contract_offers
          this.OfferRecords = res.data.OfferRecords
          this.record.id = res.data.RecId
          this.errorShow = false
          this.successShow = true
          this.newData()
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    // ==================================================================
    deleteData () {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingSave = true
          axios.post(this.$apiURL + 'deleteContractOffers', {
            token: localStorage.getItem('token'),
            id: this.record.id,
            contract_id: this.record.contract_id
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف السجل بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              this.isLoadingSave = false
              this.contract_offers = res.data
              this.OfferRecords = null
              this.newData()
              this.errorShow = false
              this.successShow = false
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.validationErrors = err.response.data.errors
              this.errorShow = true
              this.isLoadingSave = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/OM.vue